import {
  ErrorBoundary,
  ErrorFallback,
  initObservability,
} from "@a2z/observability";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { markSellerNativeDocument } from "./lib/native/runtime";
import { NativeOtaBootstrap } from "./app/native/NativeOtaBootstrap";
import "./app/styles.css";

markSellerNativeDocument();

initObservability({
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment:
      (import.meta.env.VITE_APP_ENV as string | undefined) ??
      import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    replaysSessionSampleRate: import.meta.env
      .VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: import.meta.env
      .VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
    isProd: import.meta.env.PROD,
    apiHostnames: ["a2z-orders.shop", "a2zorders.com", "trioty.com"],
  },
  clarity: {
    projectId: import.meta.env.VITE_CLARITY_PROJECT_ID,
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary fallback={<ErrorFallback />}>
      <NativeOtaBootstrap />
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
